var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as ReactDOM from 'react-dom';
// Let compiler not to search module usage
const fullClone = Object.assign({}, ReactDOM);
const { version, render: reactRender, unmountComponentAtNode } = fullClone;
let createRoot;
function initCreateRoot() {
    return __awaiter(this, void 0, void 0, function* () {
        if (createRoot)
            return;
        const mainVersion = Number((version || '').split('.')[0]);
        // React 18+ 使用 createRoot
        if (mainVersion >= 18) {
            try {
                /* @vite-ignore */
                const client = yield import('react-dom/client');
                if (client.createRoot) {
                    createRoot = client.createRoot;
                }
            }
            catch (error) {
                // 如果动态导入失败，回退到旧版本渲染
                // Silent error
            }
        }
    });
}
/**
 * <zh/> 切换警告
 *
 * <en/> Toggle warning
 * @param skip <zh/> 是否跳过警告 | <en/> Whether to skip the warning
 */
function toggleWarning(skip) {
    const { __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED } = fullClone;
    if (__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED &&
        typeof __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === 'object') {
        __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.usingClientEntryPoint = skip;
    }
}
const MARK = '__rc_react_root__';
/**
 * <zh/> 渲染 React 节点(React >= 18)
 *
 * <en/> Render React node(React >= 18)
 * @param node - <zh/> React 节点 | <en/> React node
 * @param container - <zh/> 容器 | <en/> Container
 */
function modernRender(node, container) {
    toggleWarning(true);
    const root = container[MARK] || createRoot(container);
    toggleWarning(false);
    root.render(node);
    container[MARK] = root;
}
/**
 * <zh/> 使用旧的 React 渲染
 *
 * <en/> Use old React render
 * @param node - <zh/> React 节点 | <en/> React node
 * @param container - <zh/> 容器 | <en/> Container
 */
function legacyRender(node, container) {
    reactRender(node, container);
}
/**
 * <zh/> 渲染 React 节点(兼容 React 16 ~ 18)
 *
 * <en/> Render React node(Compatible with React 16 ~ 18)
 * @param node - <zh/> React 节点 | <en/> React node
 * @param container - <zh/> 容器 | <en/> Container
 */
export function render(node, container) {
    return __awaiter(this, void 0, void 0, function* () {
        yield initCreateRoot();
        if (createRoot)
            modernRender(node, container);
        else
            legacyRender(node, container);
    });
}
/**
 * <zh/> 卸载 React 节点(React >= 18)
 *
 * <en/> Unmount React node(React >= 18)
 * @param container - <zh/> 容器 | <en/> Container
 * @returns <zh/> Promise | <en/> Promise
 */
function modernUnmount(container) {
    return __awaiter(this, void 0, void 0, function* () {
        // Delay to unmount to avoid React 18 sync warning
        return Promise.resolve().then(() => {
            var _a;
            (_a = container[MARK]) === null || _a === void 0 ? void 0 : _a.unmount();
            delete container[MARK];
        });
    });
}
/**
 * <zh/> 卸载 React 节点(React < 18)
 *
 * <en/> Unmount React node(React < 18)
 * @param container - <zh/> 容器 | <en/> Container
 */
function legacyUnmount(container) {
    unmountComponentAtNode(container);
}
/**
 * <zh/> 卸载 React 节点(兼容 React 16 ~ 18)
 *
 * <en/> Unmount React node(Compatible with React 16 ~ 18)
 * @param container - <zh/> 容器 | <en/> Container
 * @returns <zh/> Promise | <en/> Promise
 */
export function unmount(container) {
    return __awaiter(this, void 0, void 0, function* () {
        yield initCreateRoot();
        if (createRoot) {
            // Delay to unmount to avoid React 18 sync warning
            return modernUnmount(container);
        }
        legacyUnmount(container);
    });
}
//# sourceMappingURL=render.js.map